import { graphql } from 'react-apollo'

import { Option } from 'monapt'
import { compose, withPropsOnChange } from 'recompose'

import { AcceptanceDocument } from 'generated/types'
import { WithOptimizelyProps, withOptimizely } from 'utils/Optimizely'

import referralAgreementQuery from './gql/referralAgreement.query.gql'

const REFERRAL_DISCLOSURE = 'referral_disclosure'

type Handler = (props: Props) => void

type GqlProps = {
  acceptanceDocuments: AcceptanceDocument[]
  loading: boolean
}

export type Props = {
  referralDisclosureRequired: boolean
  referralDisclosureRequiredLoading: boolean
  route: (config: any) => void
}

const withReferralDisclosureRequired = (handler: Handler = _ => null) =>
  compose<Props, WithOptimizelyProps>(
    withOptimizely,

    graphql<Props, GqlProps, {}, {}>(referralAgreementQuery, {
      options: {
        fetchPolicy: 'network-only',
      },
      props: ({ data }) => {
        if (!data.loading) {
          const agreementRequired = Boolean(
            Option(data.acceptanceDocuments)
              .flatMap(acceptanceDocuments => Option(acceptanceDocuments))
              .getOrElse(() => [])
              .find(document => document.type === REFERRAL_DISCLOSURE),
          )

          return {
            referralDisclosureRequired: agreementRequired,
            referralDisclosureRequiredLoading: data.loading,
          } as Props
        }

        return {
          referralDisclosureRequiredLoading: data.loading,
        }
      },
    }),

    withPropsOnChange(['referralDisclosureRequired', 'referralDisclosureRequiredLoading'], handler),
  )

export default withReferralDisclosureRequired
